<div class="wrapper__contentComponent--expediente container my-5">
  <!-- Main panel -->
  <ng-container *ngIf="listFlag">
    <div
      class="d-flex justify-content-between align-items-center mb-3"
      *ngIf="!subDominioFlag">
      <h2>Lista de funcionalidades</h2>
      <button
        id="crearDominio"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="crearDominio()">
        <span class="govco-svg govco-plus-circle me-2"></span>
        Crear funcionalidad
      </button>
    </div>
    <div class="d-flex justify-content-between mb-3">
      <p class="justify-text">
        Esta sección permite gestionar las distintas funcionalidades presentes
        en Justifacil a través de la creación, edición y eliminación de
        dominios. Un dominio es un conjunto de datos que define una
        funcionalidad específica dentro del sistema. Cada dominio puede tener un
        estado asociado (activo o inactivo) y puede ser modificado por
        diferentes usuarios. La gestión de dominios es esencial para mantener la
        integridad y el correcto funcionamiento del sistema, permitiendo a los
        administradores controlar qué funcionalidades están disponibles para
        beneficiar la configuración de Justino.
      </p>
    </div>
    <div class="d-flex justify-content-end mb-3">
      <div class="input-group w-50">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por nombre"
          [(ngModel)]="searchTerm" />
        <span class="input-group-text">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-search"
            viewBox="0 0 16 16">
            <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.415l-3.85-3.85a1.007 1.007 0 0 0-.115-.098zm-5.442 1.398a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z" />
          </svg>
        </span>
      </div>
    </div>
    <!-- Tabla de dominios -->
    <div class="table-container" *ngIf="dominios.length > 0; else noData">
      <table class="table table-striped table-bordered">
        <thead class="custom-header">
          <tr>
            <th>Nombre</th>
            <th>Estado</th>
            <th>Fecha Modificación</th>
            <th>Usuario</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let dominio of dominios
                | filter: searchTerm : 'Nombre'
                | paginate: { itemsPerPage: 5, currentPage: currentPage }
            "
            class="hover-effect">
            <td>{{ dominio.Nombre }}</td>
            <td>{{ dominio.Estado }}</td>
            <td>{{ dominio.FechaModificacion | date: 'yyyy-MM-dd HH:mm' }}</td>
            <td>{{ dominio.UsuarioModificacion }}</td>
            <td>
              <button
                class="btn btn-sm btn-outline-primary me-2"
                (click)="editarDominio(dominio)">
                Editar
              </button>
              <button
                *ngIf="dominio.Estado === 'Activo'"
                class="btn btn-sm btn-outline-primary"
                (click)="confirmacionDeshabilitacion(dominio)">
                Deshabilitar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Pagination Controls -->
      <pagination-controls
        (pageChange)="currentPage = $event"
        previousLabel="Anterior"
        nextLabel="Siguiente"
        class="d-flex justify-content-center mt-3">
      </pagination-controls>
    </div>
    <!-- Plantilla para mostrar mensaje si no hay datos -->
    <ng-template #noData>
      <div class="no-data-container">
        <p>{{ mensaje }}</p>
      </div>
    </ng-template>
  </ng-container>
  <!-- Read panel -->
  <ng-container *ngIf="readFlag">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Formulario de Funcionalidad</h2>
      <button
        id="detalleDominio"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="volverElemento()">
        <span class="govco-svg govco-arrow-circle-left me-2"></span>
        Volver a la lista
      </button>
    </div>
    <form [formGroup]="dominioForm" (ngSubmit)="submitForm()">
      <div class="row">
        <div *ngFor="let field of nomDesForm" class="col-md-{{ field.width }}">
          <div class="mb-3">
            <label [for]="field.name" class="form-label"
              >{{ field.label
              }}<span
                *ngIf="field.required"
                _ngcontent-ng-c3465959523=""
                class="text-danger">
                *</span
              ></label
            >
            <!-- Text Input -->
            <input
              *ngIf="field.type === 'text'"
              [id]="field.name"
              [type]="field.type"
              class="form-control"
              [formControlName]="field.name"
              [readonly]="isReadOnly" />
            <!-- Textarea -->
            <textarea
              *ngIf="field.type === 'textarea'"
              [id]="field.name"
              class="form-control"
              [formControlName]="field.name"
              rows="3"
              [readonly]="isReadOnly"></textarea>
            <!-- Select Dropdown -->
            <select
              *ngIf="field.type === 'select'"
              [id]="field.name"
              class="form-select"
              [formControlName]="field.name"
              [disabled]="isReadOnly">
              <option *ngFor="let option of estados" [value]="option">
                {{ option }}
              </option>
            </select>
            <!-- Validation Error Messages -->
            <div *ngIf="getErrorMessage(field.name)" class="text-danger">
              {{ getErrorMessage(field.name) }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 d-flex gap-2">
        <button
          type="button"
          class="btn-govco fill-btn-govco"
          (click)="toggleEdit()"
          *ngIf="isReadOnly">
          Editar
        </button>
        <button
          type="submit"
          class="btn-govco fill-btn-govco"
          *ngIf="!isReadOnly">
          Guardar
        </button>
        <button
          type="button"
          class="btn-govco btn-govco"
          (click)="toggleEdit()"
          *ngIf="!isReadOnly">
          Cancelar
        </button>
      </div>
    </form>
    <!-- Conjunto de datos -->
    <div class="d-flex justify-content-between align-items-center mb-3 mt-5">
      <h4 class="title-section">Conjunto de datos</h4>
    </div>
    <div *ngIf="dominio.DataSet; else noDataC">
      <div class="no-data-container">
        <p style="color: green">
          Identificador del conjunto de datos {{ dominio.DataSet }}
        </p>
      </div>
    </div>
    <!-- Plantilla para mostrar mensaje si no hay datos -->
    <ng-template #noDataC>
      <div class="no-data-container">
        <p>Conjunto de datos vacio.</p>
      </div>
    </ng-template>
    <!-- Carga de nuevo archivo -->
    <div
      class="upload-container mt-5"
      [class.dragging]="isDragging"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <h5>Cargar nuevo archivo</h5>
      <div class="upload-box">
        <label for="fileUpload">
          <span class="upload-icon">⬆</span>
          <br />
          Arrastre el archivo .TXT
        </label>
        <input
          id="fileUpload"
          type="file"
          class="file-input"
          accept=".txt"
          (change)="onFileSelected($event)" />
      </div>
    </div>
    <!-- Formulario edición contenido de dataset -->
    <div *ngIf="dominio.DataSet" class="mb-5 mt-5">
      <h5 class="text-center">Edita el contenido del dataset</h5>
      <div class="w-100 mt-3 mb-5">
        <form [formGroup]="datasetform">
          <quill-editor
            class="form-control mb-3"
            formControlName="Contenido"
            [modules]="quillConfig"
            placeholder="Ingresa el texto aquí...">
          </quill-editor>
          <div class="d-flex justify-content-start gap-2">
            <button
              (click)="this.editarContenidoDataset()"
              type="submit"
              class="btn-govco fill-btn-govco">
              Guardar
            </button>
            <button
              (click)="this.eliminarDataset()"
              type="button"
              class="btn-govco bg-danger text-white">
              Eliminar
            </button>
          </div>
        </form>
      </div>
    </div>
  </ng-container>
</div>
<div *ngIf="modalNDFlag">
  <app-modal-nom-des
    [elements]="dominios"
    (ndEmitter)="registrarDominio($event)">
  </app-modal-nom-des>
</div>
